import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import Loader from '../../common/Loader';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PatientList = ({ setStep, patientList, setSelectedPatient, selectedPatient, validated, handleSubmit, setVerify, loaders }) => {
    const { t } = useTranslation();
    let locale = localStorage.getItem("locale");
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(`/${locale}/`)
    };

    const handlePhone = () => {
        setVerify((prev) => ({
            ...prev,
            phoneNumber: {
                value: "",
                isInValid: false,
            },
        }));
        setSelectedPatient({ patientId: "" })
        setStep(1)
    }

    const handlePatientClick = (data) => {
        setSelectedPatient(data);
    };

    useEffect(() => {
        setSelectedPatient({ patientId: "" })
    }, [])

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="appoi-nav-main">
                <div className="appoi-nav-inner-main">
                    <button
                        onClick={handleBack}
                        className="btn back-button"
                    >
                        <i className="fas fa-arrow-left filled"></i>
                        <span>{t("back")}</span>
                    </button>
                </div>
            </div>
            <div className="appoi-detail-inner-right">
                <div className="d-flex align-items-center gap-4 py-2">
                    <h5>{`${t("manage_patient")}`}</h5>
                </div>

                <div className="row gy-3 pb-4">
                    {loaders.code ?
                        (<div className="col-12 text-center">
                            <p>
                                <Loader color="primary" size="sm" />
                            </p>
                        </div>) : patientList.length === 0 ? (
                            <div className="col-12 text-center">
                                <p className="text-muted">{t("no_patient_found")}</p>
                            </div>
                        ) : (
                            patientList.map((pat, key) => (
                                <div
                                    className={`patient-name col-lg-3 col-md-4 col-sm-4 col-6`}
                                    key={key}
                                >
                                    <div>
                                        <button
                                            type="button"
                                            className={`border btn w-100 ${pat.patientId === selectedPatient.patientId
                                                ? "activeBtn text-white"
                                                : ""
                                                }`}
                                            onClick={() => handlePatientClick(pat)}
                                        >
                                            {`${pat.firstName || ""} ${pat.lastName || ""}`}
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                </div>

                <div className="d-flex flex-column flex-md-row gap-2 mt-4">
                    <button
                        type="submit"
                        className="border btn w-100 activeBtn verify-btn text-white"
                        disabled={!selectedPatient.patientId}
                    >
                        {t("continue")}
                    </button>
                    <button
                        type="button"
                        className="border btn w-100 activeBtn verify-btn text-white"
                        onClick={handlePhone}>
                        {t("change_phone_number")}
                    </button>
                    <button
                        type="button"
                        className="border btn w-100 activeBtn verify-btn text-white"
                        onClick={handlePhone}>
                        {t("no")}
                    </button>
                </div>
            </div>
        </Form>
    )
}

export default PatientList